/**
 * MM Hero Banner Manager - Moon Moon Agency
 * Init Splide loop + flèches custom + compteur X/N par section.
 * Split layout : compteurs et flèches sont rendus PAR slide (dans le bloc blanc),
 * tous reliés au même Splide.
 *
 * Cf. .claude/rules/javascript.md (Manager pattern).
 */

const MMHeroBannerManager = {
	config: {
		selectors: {
			section:  '[data-hero-banner]',
			slider:   '[data-hero-slider]',
			prev:     '[data-hero-prev]',
			next:     '[data-hero-next]',
			counter:  '[data-hero-counter]',
		},
	},

	init() {
		document.querySelectorAll(this.config.selectors.section).forEach(s => this._initSection(s));
	},

	_initSection(section) {
		const sliderEl = section.querySelector(this.config.selectors.slider);
		if (!sliderEl || typeof Splide === 'undefined') return;
		if (sliderEl._splide) return;

		let config;
		try { config = JSON.parse(sliderEl.dataset.splide || '{}'); }
		catch (_) { config = {}; }

		const splide = new Splide(sliderEl, config).mount();
		sliderEl._splide = splide;

		const prevs = section.querySelectorAll(this.config.selectors.prev);
		const nexts = section.querySelectorAll(this.config.selectors.next);
		const counters = section.querySelectorAll(this.config.selectors.counter);

		prevs.forEach(b => b.addEventListener('click', () => splide.go('<')));
		nexts.forEach(b => b.addEventListener('click', () => splide.go('>')));

		const update = () => {
			try {
				const total = splide.length;
				/* En mode loop, Splide.index est l'index canonique de la slide. */
				const idx = splide.index;
				counters.forEach(c => { c.textContent = `${idx + 1}/${total}`; });
			} catch (_) { /* splide destroyed */ }
		};
		splide.on('mounted move moved resized', update);
		update();

		/* Pause toutes les vidéos sauf celle de la slide active.
		 * Splide émet "active" sur la slide qui devient active et "inactive" sur les autres.
		 * En mode loop, Splide clone les slides : on cible la slide d'origine + ses clones. */
		this._setupVideoPlayback(splide);
	},

	_setupVideoPlayback(splide) {
		const pauseVideos = (slideEl) => {
			slideEl.querySelectorAll('video').forEach(v => { try { v.pause(); } catch (_) {} });
		};
		const playVideos = (slideEl) => {
			slideEl.querySelectorAll('video').forEach(v => {
				try {
					v.muted = true; /* requis pour autoplay programmatique */
					const p = v.play();
					if (p && typeof p.catch === 'function') p.catch(() => {});
				} catch (_) {}
			});
		};

		/* État initial : tout en pause sauf la slide active */
		splide.Components.Slides.forEach(s => pauseVideos(s.slide));
		const activeSlide = splide.Components.Slides.getAt(splide.index);
		if (activeSlide) playVideos(activeSlide.slide);

		splide.on('active', (slide) => { if (slide && slide.slide) playVideos(slide.slide); });
		splide.on('inactive', (slide) => { if (slide && slide.slide) pauseVideos(slide.slide); });
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => MMHeroBannerManager.init());
} else {
	MMHeroBannerManager.init();
}

/* Theme editor : la section re-rendue n'est plus observee → re-init slider + videos lazy (sources en data-src) */
document.addEventListener('shopify:section:load', (e) => {
	if (!e.target.querySelector('[data-hero-banner]')) return;
	MMHeroBannerManager.init();
	window.VideoManager?.init();
});

window.MMHeroBannerManager = MMHeroBannerManager;
